import { AssignmentOutlinedIcon, Flex, Text } from '@shared/components';

interface MyTaskCardListEmptyStateProps {
  taskStatus: 'TODO' | 'IN_PROGRESS' | 'COMPLETED';
}

const TASK_STATUS_LABEL = {
  TODO: 'งานที่ต้องดำเนิน',
  IN_PROGRESS: 'งานที่กำลังดำเนินอยู่',
  COMPLETED: 'งานที่เสร็จสิ้น',
};

export default function MyTaskCardListEmptyState(props: Readonly<MyTaskCardListEmptyStateProps>) {
  const { taskStatus } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[50],
        border: `1px dashed ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(4),
        py: theme.spacing(6),
      })}
    >
      <AssignmentOutlinedIcon
        sx={{
          color: (theme) => theme.palette.grey[400],
          fontSize: '48px',
        }}
      />

      <Text variant='h4' sx={{ textAlign: 'center' }}>
        ยังไม่มี{TASK_STATUS_LABEL[taskStatus]}
      </Text>
    </Flex>
  );
}
